// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Post_PostTop__YD3ub {
  background-color: #1ea7ae;
  background-color: #39606e;
  color: #fff;
}

.Post_Content4__LMQP2 {
  max-height: 52px;
  overflow: hidden;
}

.Post_NamePosMo__48PeX {
  height: 19px;
  overflow: hidden;
}

.Post_Date__7OkAl {
  font-size: .7rem;
}

.Post_NamePos__hrirD {
  overflow: hidden;
  min-height: 30px;
}

.Post_PostTop2__gZ1tT {
  background-color: #39606e;
  color: #fff;
}

.Post_ContentUnOpen__4qJ0T {
  background-color: #39606e;
  background-color: #000;
  /* background-color: #3e626f; */
  border-radius: 25px;
  color: #F5F5F5;
  cursor: pointer;
  font-weight: 700;
}

.Post_ContentTitleUnOpen__gxhdG {
  color: #5fe9f0;
  font-weight: 400;
}

.Post_ContentUnOpen__4qJ0T:hover {
  background-color: #fafafa;
  color: rgba(129, 102, 21, 0.99);
  font-weight: 700;
}

.Post_ContentUnOpen__4qJ0T:hover .Post_ContentTitleUnOpen__gxhdG {
  color: #39606e;
  font-weight: 400;
}

.Post_ContentOpened__uCfhy {
  background-color: #fafafa;
  color: rgba(129, 102, 21, 0.99);
  cursor: pointer;
  border-radius: 25px;
  font-weight: 700;
}

.Post_ContentTitleOpened__Lzmlb {
  color: #747686;
  color: #39606e;
  font-weight: 400;
}

.Post_ContentOpened__uCfhy:hover {
  background-color: #39606e;
  background-color: #000;
  color: #fff;
  font-weight: 700;
}

.Post_ContentOpened__uCfhy:hover .Post_ContentTitleOpened__Lzmlb {
  color: #5fe9f0;
}

/* post page */
.Post_ContentOpened2__COQxA {
  background-color: #fafafa;
  color: rgba(129, 102, 21, 0.99);
  cursor: pointer;
  font-weight: 700;
}

.Post_ContentOpened2__COQxA:hover {
  /* background-color: #39606e; */
  color: #000;
  font-weight: 700;
}

.Post_ContentOpened2__COQxA:hover .Post_ContentTitleOpened__Lzmlb {
  color: #5fe9f0;
}

.Post_Posit__lwv-x {
  color: #fff;
  font-size: .75rem;
  font-style: italic;
}

.Post_WhiteName__-o7nD {
  color: #fff;
}

.Post_ProfileImage__vXZi9 {
    object-fit: cover;
    width: 50px;
    height: 50px;
    margin: 4px;
  }

.Post_BreakIm__nAK9j {
  border-top: 1px solid #fff;
}

.Post_Images__rFMur {
  object-fit: contain;
  height: 500px;
  width: 100%;
}

.Post_ImagesIndex__i6N2M {
    object-fit: contain; 
    height: 300px;
    width: 100%;
    border-radius: 20px; 
    padding-bottom: 0px;
    padding-top: 12px;
}

.Post_iframe__Blm1R {
    pointer-events: auto;
    object-fit: contain; 
    height: 296px;
    width: 100%;
    border-radius: 2px; 
    padding-top: 12px;
    border: 1px solid #fff;
}

.Post_ImagesLand__Hm2o0 {
  object-fit: contain;
  height: 300px;
  width: 100%;
  border-radius: 20px;
}

i:hover {
  color: #2142b2;
}

.Post_SmallI__hj3eh {
  font-size: .6rem;
  padding-top: 6px;
}

.Post_Star__Yjr2n {
  color: gold;
  font-size: .6rem;
}

.Post_Heart__N\\+eia {
  color: crimson;
  font-size: .6rem;
  padding-top: 12px;
}

.Post_Comment__mjv1X {
  color: #f832f5;
  padding-top: 12px;
  font-size: .6rem;
}

/* .GoToScene {
  color: #fff;
  font-weight: 700;
  font-size: .75em;
  cursor: pointer;
}
.GoToScene:hover {
  color: #000;
}

.GoToScene a {
  color: #79f5ef;
  font-weight: 700;
  font-size: .75em;
  cursor: pointer;
}
.GoToScene a:hover {
  color: #e9f1f1;
} */

/* .GoToScene:hover {
  background-color: #000;
  color: #fff;
  cursor: pointer;
} */

.Post_FullsizeText__auhN0 {
  color: rgb(36, 184, 184);
  font-style: italic;
  font-size: .70rem;
}

.Post_FullsizeText__auhN0:hover {
  color: rgb(14, 66, 66);
  cursor: pointer;
}

.Post_SubTitle__OHG3p {
  background-color: #e8f0f1;
  font-weight: 700;
}

.Post_GoldDark__kQjKo {
  color: rgba(129, 102, 21, 0.99);
}

.Post_BorderRight__yRscS {
  border-right: 1px solid #d0d9db;
}

.Post_Role__Qf4vo {
  color: #747686;
}

.Post_BoldTitle__Ufubh {
  font-weight: 700;
  background-color: #d6fcff;
}

.Post_ImageBox__n-L0F {
  border: 2px solid #fff;
}

.Post_ImageBox2__GTbBq {
  border: 1px solid #d0d9db;
}

.Post_PostCard__1btlA {
  border: 1px solid #fff;
}

.Post_Italic__6pmkz {
  font-style: italic;
}

.Post_BoldScene__pwS7G {
  color: rgba(129, 102, 21, 0.99);
}

.Post_Icon__dqIGJ i {
  color: #fff;
}

.Post_Icon__dqIGJ i:hover {
  color: #2142b2;
}

.Post_Icons__YDU1n {
  font-size: .6rem;
}

.Post_Go__93mCv i {
  font-size: .7rem;
}

.Post_Post__MK9yw figure,
h5 {
  margin: 0 0;
}

.Post_Edit__j67QW {
  color: #fff;
}

.Post_Edit__j67QW:hover {
  color: #fff;
}

.Post_PostTopText__imRva {
  color: #205a6e;
}

.Post_Red__jH2\\+g {
  color: crimson;
}

.Post_White__mpF7e {
  color: #fff;
}

.Post_ContentDep__RDBem {
  background-color: #444a4c;
  color: #79f5ef;
  cursor: pointer;
}

.Post_ContentDep__RDBem:hover {
  background-color: #232d30;
  color: #fff;
  cursor: pointer;
}

.Post_Card__k8AH6 i {
  color: #fff;
}

@media screen and (min-width: 1800px) {
  .Post_ImagesIndex__i6N2M {
  height: 500px;
  }

  .Post_iframe__Blm1R {
  height: 500px;
  }
}

@media screen and (max-width: 780px) {
  .Post_ImageBox__n-L0F {
    border: 2px solid #dee1f7;
  }

  .Post_ImageBox2__GTbBq {
    border: 2px solid #fff;
  }
}

@media screen and (max-width: 600px) {
  .Post_Posit__lwv-x {
  color: #000;
}

.Post_ContentTitleUnOpen__gxhdG {
  font-size: .75rem;
}

.Post_ContentTitleOpened__Lzmlb {
  font-size: .75rem;
}

.Post_ContentT__bKCox {
font-size: .6rem !important;
}

  .Post_ContentOpened__uCfhy {
  border-radius: 0px;
}

.Post_ContentUnOpen__4qJ0T {
  border-radius: 0px;
}

.Post_SmallI__hj3eh {
  font-size: .6rem;
  padding-top: 1px;
}

.Post_Star__Yjr2n {
  font-size: .5rem;
}

.Post_Heart__N\\+eia {
  color: crimson;
  font-size: .5rem;
  padding-top: 8px;
}

.Post_Comment__mjv1X {
  font-size: .5rem;
  padding-top: 4px;
}

.Post_Date__7OkAl {
  font-size: .6rem;
}

.Post_Icon__dqIGJ i {
  font-size: .8rem;
}
}`, "",{"version":3,"sources":["webpack://./src/styles/Post.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;AAEF;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;;;;GAIG;;AAEH;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;EACA,aAAa;EACb;;EAEA;EACA,aAAa;EACb;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;EACA,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AACA,2BAA2B;AAC3B;;EAEE;EACA,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA","sourcesContent":[".PostTop {\n  background-color: #1ea7ae;\n  background-color: #39606e;\n  color: #fff;\n}\n\n.Content4 {\n  max-height: 52px;\n  overflow: hidden;\n}\n\n.NamePosMo {\n  height: 19px;\n  overflow: hidden;\n}\n\n.Date {\n  font-size: .7rem;\n}\n\n.NamePos {\n  overflow: hidden;\n  min-height: 30px;\n}\n\n.PostTop2 {\n  background-color: #39606e;\n  color: #fff;\n}\n\n.ContentUnOpen {\n  background-color: #39606e;\n  background-color: #000;\n  /* background-color: #3e626f; */\n  border-radius: 25px;\n  color: #F5F5F5;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.ContentTitleUnOpen {\n  color: #5fe9f0;\n  font-weight: 400;\n}\n\n.ContentUnOpen:hover {\n  background-color: #fafafa;\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 700;\n}\n\n.ContentUnOpen:hover .ContentTitleUnOpen {\n  color: #39606e;\n  font-weight: 400;\n}\n\n.ContentOpened {\n  background-color: #fafafa;\n  color: rgba(129, 102, 21, 0.99);\n  cursor: pointer;\n  border-radius: 25px;\n  font-weight: 700;\n}\n\n.ContentTitleOpened {\n  color: #747686;\n  color: #39606e;\n  font-weight: 400;\n}\n\n.ContentOpened:hover {\n  background-color: #39606e;\n  background-color: #000;\n  color: #fff;\n  font-weight: 700;\n}\n\n.ContentOpened:hover .ContentTitleOpened {\n  color: #5fe9f0;\n}\n\n/* post page */\n.ContentOpened2 {\n  background-color: #fafafa;\n  color: rgba(129, 102, 21, 0.99);\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.ContentOpened2:hover {\n  /* background-color: #39606e; */\n  color: #000;\n  font-weight: 700;\n}\n\n.ContentOpened2:hover .ContentTitleOpened {\n  color: #5fe9f0;\n}\n\n.Posit {\n  color: #fff;\n  font-size: .75rem;\n  font-style: italic;\n}\n\n.WhiteName {\n  color: #fff;\n}\n\n.ProfileImage {\n    object-fit: cover;\n    width: 50px;\n    height: 50px;\n    margin: 4px;\n  }\n\n.BreakIm {\n  border-top: 1px solid #fff;\n}\n\n.Images {\n  object-fit: contain;\n  height: 500px;\n  width: 100%;\n}\n\n.ImagesIndex {\n    object-fit: contain; \n    height: 300px;\n    width: 100%;\n    border-radius: 20px; \n    padding-bottom: 0px;\n    padding-top: 12px;\n}\n\n.iframe {\n    pointer-events: auto;\n    object-fit: contain; \n    height: 296px;\n    width: 100%;\n    border-radius: 2px; \n    padding-top: 12px;\n    border: 1px solid #fff;\n}\n\n.ImagesLand {\n  object-fit: contain;\n  height: 300px;\n  width: 100%;\n  border-radius: 20px;\n}\n\ni:hover {\n  color: #2142b2;\n}\n\n.SmallI {\n  font-size: .6rem;\n  padding-top: 6px;\n}\n\n.Star {\n  color: gold;\n  font-size: .6rem;\n}\n\n.Heart {\n  color: crimson;\n  font-size: .6rem;\n  padding-top: 12px;\n}\n\n.Comment {\n  color: #f832f5;\n  padding-top: 12px;\n  font-size: .6rem;\n}\n\n/* .GoToScene {\n  color: #fff;\n  font-weight: 700;\n  font-size: .75em;\n  cursor: pointer;\n}\n.GoToScene:hover {\n  color: #000;\n}\n\n.GoToScene a {\n  color: #79f5ef;\n  font-weight: 700;\n  font-size: .75em;\n  cursor: pointer;\n}\n.GoToScene a:hover {\n  color: #e9f1f1;\n} */\n\n/* .GoToScene:hover {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer;\n} */\n\n.FullsizeText {\n  color: rgb(36, 184, 184);\n  font-style: italic;\n  font-size: .70rem;\n}\n\n.FullsizeText:hover {\n  color: rgb(14, 66, 66);\n  cursor: pointer;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.GoldDark {\n  color: rgba(129, 102, 21, 0.99);\n}\n\n.BorderRight {\n  border-right: 1px solid #d0d9db;\n}\n\n.Role {\n  color: #747686;\n}\n\n.BoldTitle {\n  font-weight: 700;\n  background-color: #d6fcff;\n}\n\n.ImageBox {\n  border: 2px solid #fff;\n}\n\n.ImageBox2 {\n  border: 1px solid #d0d9db;\n}\n\n.PostCard {\n  border: 1px solid #fff;\n}\n\n.Italic {\n  font-style: italic;\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n}\n\n.Icon i {\n  color: #fff;\n}\n\n.Icon i:hover {\n  color: #2142b2;\n}\n\n.Icons {\n  font-size: .6rem;\n}\n\n.Go i {\n  font-size: .7rem;\n}\n\n.Post figure,\nh5 {\n  margin: 0 0;\n}\n\n.Edit {\n  color: #fff;\n}\n\n.Edit:hover {\n  color: #fff;\n}\n\n.PostTopText {\n  color: #205a6e;\n}\n\n.Red {\n  color: crimson;\n}\n\n.White {\n  color: #fff;\n}\n\n.ContentDep {\n  background-color: #444a4c;\n  color: #79f5ef;\n  cursor: pointer;\n}\n\n.ContentDep:hover {\n  background-color: #232d30;\n  color: #fff;\n  cursor: pointer;\n}\n\n.Card i {\n  color: #fff;\n}\n\n@media screen and (min-width: 1800px) {\n  .ImagesIndex {\n  height: 500px;\n  }\n\n  .iframe {\n  height: 500px;\n  }\n}\n\n@media screen and (max-width: 780px) {\n  .ImageBox {\n    border: 2px solid #dee1f7;\n  }\n\n  .ImageBox2 {\n    border: 2px solid #fff;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .Posit {\n  color: #000;\n}\n\n.ContentTitleUnOpen {\n  font-size: .75rem;\n}\n\n.ContentTitleOpened {\n  font-size: .75rem;\n}\n\n.ContentT {\nfont-size: .6rem !important;\n}\n\n  .ContentOpened {\n  border-radius: 0px;\n}\n\n.ContentUnOpen {\n  border-radius: 0px;\n}\n\n.SmallI {\n  font-size: .6rem;\n  padding-top: 1px;\n}\n\n.Star {\n  font-size: .5rem;\n}\n\n.Heart {\n  color: crimson;\n  font-size: .5rem;\n  padding-top: 8px;\n}\n\n.Comment {\n  font-size: .5rem;\n  padding-top: 4px;\n}\n\n.Date {\n  font-size: .6rem;\n}\n\n.Icon i {\n  font-size: .8rem;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PostTop": `Post_PostTop__YD3ub`,
	"Content4": `Post_Content4__LMQP2`,
	"NamePosMo": `Post_NamePosMo__48PeX`,
	"Date": `Post_Date__7OkAl`,
	"NamePos": `Post_NamePos__hrirD`,
	"PostTop2": `Post_PostTop2__gZ1tT`,
	"ContentUnOpen": `Post_ContentUnOpen__4qJ0T`,
	"ContentTitleUnOpen": `Post_ContentTitleUnOpen__gxhdG`,
	"ContentOpened": `Post_ContentOpened__uCfhy`,
	"ContentTitleOpened": `Post_ContentTitleOpened__Lzmlb`,
	"ContentOpened2": `Post_ContentOpened2__COQxA`,
	"Posit": `Post_Posit__lwv-x`,
	"WhiteName": `Post_WhiteName__-o7nD`,
	"ProfileImage": `Post_ProfileImage__vXZi9`,
	"BreakIm": `Post_BreakIm__nAK9j`,
	"Images": `Post_Images__rFMur`,
	"ImagesIndex": `Post_ImagesIndex__i6N2M`,
	"iframe": `Post_iframe__Blm1R`,
	"ImagesLand": `Post_ImagesLand__Hm2o0`,
	"SmallI": `Post_SmallI__hj3eh`,
	"Star": `Post_Star__Yjr2n`,
	"Heart": `Post_Heart__N+eia`,
	"Comment": `Post_Comment__mjv1X`,
	"FullsizeText": `Post_FullsizeText__auhN0`,
	"SubTitle": `Post_SubTitle__OHG3p`,
	"GoldDark": `Post_GoldDark__kQjKo`,
	"BorderRight": `Post_BorderRight__yRscS`,
	"Role": `Post_Role__Qf4vo`,
	"BoldTitle": `Post_BoldTitle__Ufubh`,
	"ImageBox": `Post_ImageBox__n-L0F`,
	"ImageBox2": `Post_ImageBox2__GTbBq`,
	"PostCard": `Post_PostCard__1btlA`,
	"Italic": `Post_Italic__6pmkz`,
	"BoldScene": `Post_BoldScene__pwS7G`,
	"Icon": `Post_Icon__dqIGJ`,
	"Icons": `Post_Icons__YDU1n`,
	"Go": `Post_Go__93mCv`,
	"Post": `Post_Post__MK9yw`,
	"Edit": `Post_Edit__j67QW`,
	"PostTopText": `Post_PostTopText__imRva`,
	"Red": `Post_Red__jH2+g`,
	"White": `Post_White__mpF7e`,
	"ContentDep": `Post_ContentDep__RDBem`,
	"Card": `Post_Card__k8AH6`,
	"ContentT": `Post_ContentT__bKCox`
};
export default ___CSS_LOADER_EXPORT___;
